export type DmRealtimeEvent = {
  type: 'dm_message' | 'dm_conversation';
  dmId?: string;
  timestamp: string;
};

export function connectDmRealtime(onEvent: (event: DmRealtimeEvent) => void): () => void {
  const token = localStorage.getItem('accessToken');
  if (!token) {
    return () => undefined;
  }

  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8787';
  const wsBase = apiUrl.replace(/^http:/, 'ws:').replace(/^https:/, 'wss:').replace(/\/$/, '');
  const wsUrl = `${wsBase}/ws/dm?token=${encodeURIComponent(token)}`;

  let closedManually = false;
  let socket: WebSocket | null = null;
  let reconnectTimer: number | null = null;

  const connect = () => {
    socket = new WebSocket(wsUrl);

    socket.onmessage = (message) => {
      try {
        const parsed = JSON.parse(String(message.data)) as Partial<DmRealtimeEvent & { type: string }>;
        if (parsed.type === 'dm_message' || parsed.type === 'dm_conversation') {
          const baseEvent: DmRealtimeEvent = {
            type: parsed.type,
            timestamp: typeof parsed.timestamp === 'string' ? parsed.timestamp : new Date().toISOString()
          };
          onEvent({
            ...baseEvent,
            ...(typeof parsed.dmId === 'string' ? { dmId: parsed.dmId } : {})
          });
        }
      } catch {
        // Ignore malformed events.
      }
    };

    socket.onclose = () => {
      socket = null;
      if (!closedManually) {
        reconnectTimer = window.setTimeout(connect, 1500);
      }
    };
  };

  connect();

  return () => {
    closedManually = true;
    if (reconnectTimer !== null) {
      window.clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
    if (socket) {
      socket.close();
      socket = null;
    }
  };
}
